declare namespace $ {

	type $mol_view__sub_bog_music_log_view_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_bog_music_log_view_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_music_log_view_4 = $mol_type_enforce<
		ReturnType< $bog_music_log_view['sync_logging'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_bog_music_log_view_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_log_view_6 = $mol_type_enforce<
		ReturnType< $bog_music_log_view['copy'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_music_log_view_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_log_view_8 = $mol_type_enforce<
		ReturnType< $bog_music_log_view['clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_music_log_view_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__value_bog_music_log_view_16 = $mol_type_enforce<
		ReturnType< $bog_music_log_view['filter'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_music_log_view_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_view__attr_bog_music_log_view_18 = $mol_type_enforce<
		({ 
			'mol_theme': ReturnType< $bog_music_log_view['row_theme'] >,
			'bog_music_log_kind': ReturnType< $bog_music_log_view['kind_id'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_music_log_view_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_log_view_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_music_log_view extends $mol_list {
		log_rows( ): readonly(any)[]
		count_label( ): string
		Count( ): $mol_view
		version( ): string
		Version( ): $mol_view
		sync_logging( next?: boolean ): boolean
		Sync( ): $mol_check_box
		copy( next?: any ): any
		Copy( ): $mol_button_minor
		clear( next?: any ): any
		Clear( ): $mol_button_minor
		Tools( ): $mol_view
		filter( next?: string ): string
		row_theme( id: any): string
		kind_id( id: any): string
		time( id: any): string
		Time( id: any): $mol_view
		kind( id: any): string
		Kind( id: any): $mol_view
		land( id: any): string
		Land( id: any): $mol_view
		Meta( id: any): $mol_view
		text( id: any): string
		Text( id: any): $mol_view
		empty_label( ): string
		rows( ): ReturnType< $bog_music_log_view['log_rows'] >
		Head( ): $mol_view
		Filter( ): $mol_string
		Row( id: any): $mol_view
		Empty( ): $mol_view
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map